/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

export default function ExtendedStay({
    isDisabled = false,
    selected = false,
    onSelectionChange = () => {},
}) {
    const disableClass = isDisabled ? 'disabled' : '';

    return (
        <div className="per-extended-stay">
            <legend>Extended Stay</legend>
            <div className="rec-form-check-wrap">
                <label
                    htmlFor="extended-stay-checkbox"
                    className={`rec-label-checkbox ${disableClass}`}
                >
                    <input
                        type="checkbox"
                        className="rec-input-hide"
                        id="extended-stay-checkbox"
                        name="checkbox"
                        checked={selected}
                        onChange={onSelectionChange}
                        disabled={isDisabled}
                    />
                    <span className="rec-input-checkbox" />
                    Request to stay an extra day for an additional $35. This facility
                    reserves the right to reject this request before your launch depending
                    upon availability, if this happens you will be refunded your payment.
                </label>
            </div>
        </div>
    );
}

ExtendedStay.propTypes = {
    selected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onSelectionChange: PropTypes.func,
};
